<template>
  <div class="incre-decre-wrapper">
    <template v-if="loading">
      <b-spinner
        v-for="i in 3"
        :key="i"
        class="mr-1 spinnerSec"
        small
        label="Small Spinner"
        type="grow"
      ></b-spinner>
    </template>

    <b-card-text class="incre-decre-sec" v-if="!loading">
      <template v-if="qtyFinder.qty == undefined || qtyFinder.qty == 0">
        <button @click="increase" :class="bigButtonClass" class="btn-primary">
          {{ $t("addToCart") }}
          <!-- <img class="product-add-icon" src="img/cart1.png" alt="Cart Icon" /> -->
          <b-icon icon="bag" variant="black"></b-icon>
        </button>
      </template>
      <template v-if="qtyFinder.qty > 0">
        <div class="right-aligned plusMinusBtn mr-4">
          <b-icon
            @click="decrease"
            icon="dash"
            class="plus-icon"
            v-if="cartItem._id !== '67f0bd1458eeb6f746342b34'"
          ></b-icon>
          <input
            disabled="true"
            v-model="qtyFinder.qty"
            class="qty-input"
            type="text"
          />
          <b-icon
            @click="increase"
            icon="plus"
            class="plus-icon"
            v-if="cartItem._id !== '67f0bd1458eeb6f746342b34'"
          ></b-icon>
        </div>
        <button
          v-if="showGoToCart"
          @click="() => $router.push('/checkout')"
          variant="primary"
          class="product-add go-to-cart-btn btn-primary"
          :class="bigButtonClass"
        >
          Quick Checkout
          <b-icon icon="bag" variant="black"></b-icon>
        </button>
      </template>
    </b-card-text>
    <template>
      <button
        v-if="$route.path == `/checkout/`"
        @click="removeItemFromCart"
        class="remove"
      >
        {{ $t("remove") }}
      </button>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "increment-decrement",
  data() {
    return {
      loading: false,
      show: true,
    };
  },
  computed: {
    ...mapState({
      cartData: (state) => state.checkout.cartData,
      isSelfPickUp: (state) => state.checkout.isSelfPickUp,
    }),
    qtyFinder() {
      let qtyFinder = {};
      try {
        let res = this.cartData.filter((el) => el._id == this.cartItem._id);
        if (Array.isArray(res) && res.length > 0) {
          if (res[0].qty > 0) {
            qtyFinder = res[0];
          } else {
            qtyFinder.qty = 0;
          }
        } else {
          qtyFinder = {};
        }
      } catch {
        qtyFinder = {};
      }
      return qtyFinder;
    },
  },
  props: {
    cartItem: {
      default: () => {},
      type: Object,
    },
    itemId: {
      default: "",
      type: String,
    },
    callCheckout: {
      type: Boolean,
      default: false,
    },
    gotoCartVisibleKey: {
      type: Boolean,
      default: true,
    },
    bigButtonClass: {
      type: String,
      default: "product-add",
    },
    showGoToCart: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async increase() {
      if (!this.$store.state["auth"].isLoggedin) {
        this.$router.push({ name: "login" });
        return;
      }
      // if (this.cartItem._id == "67f0bd1458eeb6f746342b34") {
      // 	// this.$toasted.info("You can not change delivery charge");
      // 	// return;
      // }
      this.loading = true;
      this.show = true;
      try {
        if (this.cartData.length > 0) {
          if (this.cartData[0].provider == this.cartItem.provider) {
            await this.$store.dispatch("checkout/increaseCartQty", {
              cartItem: this.cartItem,
              callApi: this.callCheckout,
              itemId: this.itemId,
            });
            if (this.$route.name == "checkout") this.addDelveryItem();
            this.loading = false;
            if (this.callCheckout)
              await this.$store.dispatch("checkout/checkoutFinal");
          } else {
            this.$swal({
              title: `Sure??`,
              text: this.$t("swal.diffrentSeller"),
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Yes",
            }).then(async (result) => {
              if (result.value) {
                await this.$store.dispatch("checkout/clearCart");
                await this.$store.dispatch("checkout/increaseCartQty", {
                  cartItem: this.cartItem,
                  callApi: this.callCheckout,
                });
                if (this.$route.name == "checkout") this.addDelveryItem();
              }
              this.loading = false;
            });
          }
        } else {
          await this.$store.dispatch("checkout/increaseCartQty", {
            cartItem: this.cartItem,
            callApi: this.callCheckout,
          });
          if (this.$route.name == "checkout") this.addDelveryItem();
          this.loading = false;
          if (this.callCheckout)
            await this.$store.dispatch("checkout/checkoutFinal");
        }
      } catch {
        this.loading = false;
      }
    },
    async decrease() {
      // if (this.cartItem._id == "67f0bd1458eeb6f746342b34") {
      // 	// this.$toasted.info("You can not change delivery charge");
      // 	// return;
      // }
      this.loading = true;
      try {
        await this.$store.dispatch("checkout/decreaseCartQty", {
          cartItem: this.cartItem,
          callApi: this.callCheckout,
        });
        // if (this.$route.name == "checkout" && !this.isSelfPickUp) {
        //   await this.$store.dispatch("checkout/decreaseCartQty", {
        //     cartItem: { _id: "67f0bd1458eeb6f746342b34" },
        //     callApi: this.callCheckout,
        //   });
        //   await this.$store.dispatch("checkout/checkoutFinal");
        // }
        this.loading = false;
        if (this.callCheckout)
          await this.$store.dispatch("checkout/checkoutFinal");
      } catch {
        this.loading = false;
      }
    },

    async addDelveryItem() {
      if (this.isSelfPickUp) return;
      // await this.$store.dispatch("checkout/increaseCartQty", {
      //   cartItem: { _id: "67f0bd1458eeb6f746342b34" },
      //   callApi: this.callCheckout,
      // });
      this.$store.dispatch("checkout/fetchCartData", {
        shipFrom: "US",
        shipTo: "US",
        country: "US",
      });
      await this.$store.dispatch("checkout/checkoutFinal");
    },

    async removeItemFromCart() {
      await this.$store.dispatch("checkout/removeItem", {
        cartItem: this.cartItem,
        callApi: this.callCheckout,
      });
      if (this.callCheckout)
        await this.$store.dispatch("checkout/checkoutFinal");
    },
  },
};
</script>
<style scoped>
.go-to-cart {
  float: right;
}
.spinnerSec {
  margin-top: 10px;
  margin-bottom: 14px;
}
.section-slider-head button {
  color: #ff8a00;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
}
.go-to-cart {
  width: 125px;
  height: 35px;
  background-color: var(--primarycolor);
  /* border: none; */
  border-radius: 4px;
  color: red;
  font-size: 16px;
  font-weight: 100;
  cursor: pointer;
  /* margin-bottom: 11px; */
}
.go-to-cart:hover {
  /* color: var(--darkcolor);
  background-color: var(--primarycolor); */
  cursor: pointer;
  background-color: var(--darkcolor);
  font-weight: bold !important;
}

.icon-height {
  height: 19px !important;
}
.remove {
  font-size: 14px;
  color: var(--primarycolor);
  font-size: 16px;
  margin-left: 10px;
}
.add-to-cart {
  background-color: var(--darkcolor) !important;
  color: #333 !important;

  /* color: #fff !important;
  background-color: var(--primarycolor) !important; */
}
.add-to-cart:hover {
  color: #fff !important;
  background-color: var(--primarycolor) !important;
  font-weight: bold !important;
  outline: none !important;
  border: none !important;
}

.product-add {
  display: inline-block;
  font-weight: 500;
  /* color: var(--darkcolor); */
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  margin-bottom: 3px;
  margin-top: 0;
  gap: 5px;
  user-select: none;
  /* background-color: transparent; */
  border: 1px solid var(--primarycolor);
  padding: 0.375rem 0.5rem;
  font-size: 0.6875rem;
  line-height: 1.5;
  border-radius: 1.4375rem;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.product-add .b-icon {
  margin-left: 4px;
  color: #fff !important;
}
.product-add:hover .b-icon {
  color: #fff !important;
}
.product-add:hover {
  background-color: var(--primarycolor);
  color: white;
  border-color: var(--primarycolor);
  font-weight: bold !important;
}
.product-add img.product-add-icon {
  width: 12px;
  height: 12px;
}
.right-aligned {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.plusMinusBtn {
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 50px;
}
.incre-decre-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-add svg {
  font-size: 14px;
  margin-right: 5px;
}
.incre-decre-sec .plus-icon.b-icon.bi {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #f2f2f2;
  border-radius: 50px;
  cursor: pointer;
}
.incre-decre-sec {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 7px;
}
.incre-decre-sec .qty-input {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border: none;
  margin: 0px 5px;
}
.big-button {
  width: 347px;
  height: 41px;
  border-radius: 43px;
  font-size: 16px;
  position: relative;
  /* left: 45px; */
}
.big-button .b-icon {
  font-size: 15px;
}
.go-to-cart-btn {
  padding: 3px;
  min-width: 150px;
  width: 100%;
  font-size: 12px !important;
  height: 32px;
}
</style>
